<div  [formGroup]="parentEappForm">
  <ng-template #content let-modal>
    <div class="modal-header bg-primary" style="color: white;">
      <h3>{{pgHeader}}</h3><br>
    </div>
    <div class="modal-body">
      <p>Please click on your business category and select your NAICS code.</p>
      <ngb-accordion #acc="ngbAccordion">
        <ng-container *ngFor="let naics of naicsData">
          <ngb-panel>
            <ng-template ngbPanelTitle>
              <div class="text-left" style="color: black;">
                {{naics.desc1Heading}}
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <ng-container *ngFor="let desc2Data of naics.desc2Array">
                <div class="pl-3 m-3" >
                  <p> <strong>
                      {{desc2Data.desc2Heading}}
                    </strong></p>
                    
                      <ng-container *ngFor="let desc4Data of desc2Data.desc3Array; let j=index">
                    <div *ngIf="type === 'P';else setS" >
                      <input type="radio"   formControlName="pnaics"  [value]="desc4Data.naicCode + desc4Data.sicCode"
                        (click)="naicsSelected(desc4Data.naicCode,desc4Data.sicCode)" />&nbsp;&nbsp;{{desc4Data.naicCode}} &nbsp;&nbsp; -
                      &nbsp;&nbsp;{{desc4Data.desc3Heading}}&nbsp;&nbsp;{{desc4Data.sicCode}}&nbsp;&nbsp; - &nbsp;&nbsp;{{desc4Data.desc4}}
                    </div>  
                    <ng-template #setS>
                      <div >
                        <input type="radio"  formControlName="snaics" [value]="desc4Data.naicCode + desc4Data.sicCode"
                          (click)="naicsSelected(desc4Data.naicCode,desc4Data.sicCode)" />&nbsp;&nbsp;{{desc4Data.naicCode}} &nbsp;&nbsp; -
                      &nbsp;&nbsp;{{desc4Data.desc3Heading}}&nbsp;&nbsp;{{desc4Data.sicCode}}&nbsp;&nbsp; - &nbsp;&nbsp;{{desc4Data.desc4}}
                    </div>
                    </ng-template>
                       </ng-container>
                </div>
              </ng-container>
            </ng-template>
          </ngb-panel>
        </ng-container>
      </ngb-accordion>
    </div>
    <div class="modal-footer">
      <span><p class="errorMsg" *ngIf="errorSelectNaics.length > 0" >{{errorSelectNaics}}</p>&nbsp;</span>
      <span><p class="errorMsg" *ngIf="errorSelectSic.length > 0" >{{errorSelectSic}}</p>&nbsp;</span>
      <span>
        <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="submit()">Submit</button>
      </span>
    </div>
  </ng-template>
  <ng-container *ngIf="type === 'P'">
    <p><a href="javascript:void(0)" (click)="open('P')">Select Primary NAICS and SIC Code from the List </a></p>
  </ng-container>
  <ng-container *ngIf="type === 'S'">
    <p><a href="javascript:void(0)" (click)="open('S')">Select Secondary NAICS and SIC Code from the List </a></p>
  </ng-container>
</div>